/* @flow */

import {
  getEventSplashSponsors,
  getEventPlugins,
  getEventSponsorPluginLevelIsEnabled,
} from '@braindate/domain/lib/event/util';
import {
  isMembershipOnboardingCompleted,
  isMembershipOptInCompleted,
} from '@braindate/domain/lib/membership/util';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import {
  isOnboardingCompletedOnDevice,
  isSplashSeen,
} from 'src/shared/app/onboarding/selector/uiOnboardingSelectors';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import {
  sponsorshipPlugin as sponsorshipPluginKey,
  loginSplashLevel as loginSplashLevelKey,
} from 'src/shared/app/feature/settings/featureSettings';

import { isOptinDone } from 'src/shared/app/permission/util/permissionUtils';
import { isMembershipTermsAccepted } from 'src/shared/domain/membership/util/membershipUtil';

import type { State } from 'src/shared/core/type/reduxTypes';
import type { BraindateEvent } from '@braindate/domain/lib/event/type';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

// @TODO - This should be a redux selector
export function isSplashScreenShown(
  state: State,
  event: BraindateEvent,
): boolean {
  const splashSponsors = getEventSplashSponsors(event);
  const sponsorshipPlugin = getEventPlugins(event)[sponsorshipPluginKey];
  const sponsorSplashIsEnabled =
    sponsorshipPlugin &&
    getEventSponsorPluginLevelIsEnabled(sponsorshipPlugin, loginSplashLevelKey);
  return (
    !!sponsorSplashIsEnabled &&
    !getAuthenticationToken(state) &&
    !isSplashSeen(state) &&
    !!splashSponsors &&
    splashSponsors.length > 0
  );
}

// @TODO - This should be a redux selector
export function isOnboardingScreenShown(state: State): boolean {
  if (getAuthenticationToken(state)) {
    const membership = getMembership(state);

    if (membership) {
      return (
        !isOnboardingCompletedOnDevice(state) &&
        !isMembershipOnboardingCompleted(membership)
      );
    }

    return true;
  }

  return !isSplashScreenShown(state, getEventSafely(state));
}

// @TODO - This should be a redux selector
export function isPermissionScreenShown(
  state: State,
  areEmailNotificationsEnabled: boolean,
): boolean {
  const membership = getMembership(state);

  return !!membership && !isOptinDone(membership, areEmailNotificationsEnabled);
}

export function isMarketShown(state: State): boolean {
  const membership = getMembership(state);

  let isOnboardingCompleted = isOnboardingCompletedOnDevice(state);
  let isOptinCompleted;
  let areTermsAccepted;

  if (membership) {
    isOnboardingCompleted = isMembershipOnboardingCompleted(membership);
    isOptinCompleted = isMembershipOptInCompleted(membership);
    areTermsAccepted = isMembershipTermsAccepted(membership);
  }

  return !!(
    getAuthenticationToken(state) &&
    isOnboardingCompleted &&
    isOptinCompleted &&
    areTermsAccepted
  );
}
